export default "__VITE_ASSET__BsfGRzee__"